import * as t from "io-ts";
import { makeMessage } from "./shared.js";
import { areYouReady, ready, setState, triggerAction } from "./v1.js";
export { areYouReady, ready, setState, triggerAction };
export const themeV2 = t.record(t.string, t.string);
export const setTheme = makeMessage("glide:set-theme", t.type({
    theme: themeV2
}));
export const v2OutgoingMessages = t.union([setState, setTheme, areYouReady]);
export const v2IncomingMessages = t.union([ready, setState, triggerAction]);
export const V2 = {
    outgoing: v2OutgoingMessages,
    incoming: v2IncomingMessages
};
